import { Routes } from 'utils/constants';
import { NavItemType } from 'models';
import { IconTool } from '@tabler/icons';
import { MenuItemsCA } from 'routes/menu-items/index';

const SystemEventOverviewPage = (canAccessEventOverviewPage: boolean) => {
  return canAccessEventOverviewPage
    ? {
        id: 'activityEvents',
        title: 'navigation.system.activityEvents',
        type: 'item',
        url: Routes.SYSTEM.ACTIVITY_EVENTS
      }
    : {};
};

const SystemAlarmsOverviewPage = (canAccessAlarmsOverviewPage: boolean) => {
  return canAccessAlarmsOverviewPage
    ? {
        id: 'alarms',
        title: 'navigation.system.alarms',
        type: 'item',
        url: Routes.SYSTEM.ALARMS
      }
    : {};
};

const system = (menuItemsCA: MenuItemsCA): NavItemType => {
  return {
    id: 'system',
    title: '',
    type: 'group',
    children: [
      {
        id: 'system-group',
        title: 'navigation.system.group',
        type: 'collapse',
        icon: IconTool,
        children: [
          SystemEventOverviewPage(menuItemsCA.canAccessEventOverviewPage),
          SystemAlarmsOverviewPage(true) // TODO: kontextova akcia pre alarmy
        ]
      }
    ]
  };
};

export default system;
